/* eslint-disable import/no-default-export */
export default {
  status: {
    REQUESTED: 'I-9 Requested',
    IN_PROGRESS: 'I-9 In Progress',
    ALL_FORMS_RECEIVED: 'I-9 Submitted',
    // FORM_SUBMITTED: 'I-9 Submitted',
    ALL_REQUIRED_SUBMISSION_FINALIZED: 'I-9 Approved',
    // ALL_SUBMISSION_FINALIZED: 'I-9 Completed',
    // SUBMISSION_EXPIRING_DOCUMENTS: 'I-9 In Progress',
    SUBMISSION_ACCEPTED: 'I-9 Submitted',
    // SUBMISSION_COUNTERSIGNED: 'I-9 Approved',
    // SUBMISSION_REVERIFIED: 'I-9 Reverified',
    SUBMISSION_RESTARTED: 'I-9 Restarted',
    SUBMISSION_REJECTED: 'I-9 Rejected',
    NEW_FORM_SUBMISSION_REQUESTED: 'I-9 Requested',
  },
  statusFilter: {
    REQUESTED: 'Requested',
    ALL_FORMS_RECEIVED: 'Submitted',
    IN_PROGRESS: 'In Progress',
    ALL_REQUIRED_SUBMISSION_FINALIZED: 'Approved',
  },
  apiKeyRequired: 'API Key is required',
  webhookSecretRequired: 'Webhook Secret is required',
  i9SetupLabel: 'Setting Up Your WorkBright Integration',
  linkI9Label: 'Link I-9 Account',
  setupStep: 'Steps in setting up the I-9 Integration',
  finalNote: 'Steps number should always start back at #1 when starting a new "step"',
  webHookTitle: 'For setting up the webhook secret.',
  submitBtn: 'Submit',
  viewBtn: 'View',
  closeBtn: 'Close',
  save: 'Save',
  checks: 'Checks',
  keysUrlLabel: 'Keys and URL',
  apiKeyLabel: 'API Key',
  subDomainLabel: 'Sub-domain',
  webhookUrlLabel: 'Webhook URL',
  usernameLabel: 'Username',
  passwordLabel: 'Password',
  webhookSecretLabel: 'Webhook Secret',
  apiKeyPlaceholder: 'Enter WorkBright API Key',
  subDomainPlaceholder: 'Enter Sub-domain',
  usernamePlaceholder: 'Enter WorkBright username',
  passwordPlaceholder: 'Enter WorkBright password',
  linkToI9: 'If you do not have created I-9 account yet, sign up using the link below',
  selectRequiredLabel: 'Select the required checks as default',
  apiGenerationTitle: 'To Generate an API Key',
  stepGenerateWorkBrightAPIKey:
    'Login to your WorkBright account then visit ‘https://YOUR_SUBDOMAIN.workbright.com/admin/api_settings/edit‘ (replace YOUR_SUBDOMAIN with your actual subdomain)',
  stepCopyAPIKey: 'Turn on the ‘API Access’ switch, then copy and preserve the generated API Key.',
  webHookGenerationTitle: 'For generating webhook',
  stepGenerateWorkBrightWebhook1:
    'Access the Webhook settings page located at ‘https://YOUR_SUBDOMAIN.workbright.com/settings/webhooks',
  stepGenerateWorkBrightWebhooks2:
    'Create a Webhook Endpoint by entering a Name, URL, and selecting the Events you would like your endpoint to receive.',
  i9ConfigurationTitle: 'To Connect Your WorkBright Account to AppyHere',
  stepCopyWBCredentials:
    'Using the copied API Key and Webhook URL generated in your WorkBright account, fill the required fields, then click Submit.',
  defaultSuccessMessage: 'Credentials saved successfully!',
};
